export default __webpack_public_path__ + "static/media/lyrics-logo.ffaf767f.png";